/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const AirplaneLandBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M21.707 14.836a1.176 1.176 0 0 0-.656-1.385c-.855-.38-2.137-.917-3.083-1.17l-2.735-.733-3.479-9.51a.505.505 0 0 0-.343-.314l-.992-.266a.5.5 0 0 0-.63.54l.98 8.354L5.8 9.02l-.506-2.438a.504.504 0 0 0-.363-.383L3.91 5.926a.5.5 0 0 0-.633.474l-.052 3.483c.112.806.168 1.21.392 1.464.225.255.62.36 1.408.572l4.967 1.33 4.464 1.197 2.735.733c.946.253 2.326.43 3.255.528.581.062 1.11-.311 1.26-.871ZM3 19a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H3Z" /></svg>);
const AirplaneLand = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={AirplaneLandBase} {...rest} ref={ref} />);
export default AirplaneLand;